import { Routes } from '@angular/router';
import { Home } from './home';
import { Tours } from './tours';
import { TourDetail } from './tour-detail';
import { Contact } from './contact';
import { About } from './about';
import { Gallery } from './gallery';
import { Attractions } from './attractions';
import { Ayurveda } from './ayurveda';
import { NotFound } from './not-found';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'tours', component: Tours },
  { path: 'tours/:id', component: TourDetail },
  { path: 'attractions', component: Attractions },
  { path: 'ayurveda', component: Ayurveda },
  { path: 'contact', component: Contact },
  { path: 'about', component: About },
  { path: 'gallery', component: Gallery },
  { path: '404', component: NotFound },
  { path: '**', component: NotFound },
];
